export default class PropertiesTabs {
  constructor() {
    this.tabBtns = document.querySelectorAll('.properties-section__btn');

    this.init();
  }

  init() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => this.handleSwitch(e));
    });
  }

  handleSwitch(e) {
    e.preventDefault();
    const currentBtn = e.currentTarget;
    const tabId = currentBtn.dataset.id;

    //update tab btns
    this.tabBtns.forEach((btn) => {
      if (btn !== currentBtn) {
        btn.classList.remove('btn--static-full');
      } else {
        btn.classList.add('btn--static-full');
      }
    });

    //update tabs
    const tabs = document.querySelectorAll('.properties-section__section');

    tabs.forEach((tab) => {
      if (tab.dataset.id === tabId) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
  }
}
